export function isPioneerUser(user: { planEndAt?: number | null }) {
  return (user.planEndAt ?? 0) * 1000 > Date.now()
}